import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import SmartCard from '../../controls/cards/SmartCard'
import Tile from '../../layout/Tile'
import CardioLoader from '../../loaders/CardioLoader'

interface P {
    error: Error
}

function RouterError({ error }: P) {
    let myError: Error = error

    if (error instanceof Error) myError = error
    else if (typeof error === 'string') myError = new Error(error)
    else myError = new Error(error)

    return (
        <Tile.Container>
            <SmartCard style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                <CardioLoader />
                <h1>Oops!</h1>
                <p>Seems like there was an unexpected error.</p>
                <Accordion style={{ maxWidth: '80%' }}>
                    <AccordionSummary>
                        <Typography>{myError.message}</Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ overflowX: 'auto' }}>
                        <pre>
                            {myError.stack}
                        </pre>
                    </AccordionDetails>
                </Accordion>
            </SmartCard>
        </Tile.Container>
    )
}

export default RouterError
